/* unplugin-vue-components disabled */import script from "./problem.vue?vue&type=script&setup=true&lang=js"
export * from "./problem.vue?vue&type=script&setup=true&lang=js"

import "./problem.vue?vue&type=style&index=0&id=20ea9108&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20ea9108"]])

export default __exports__